import React from 'react';
import IsConnected from '../../IsConnected/IsConnected'
import EditAmbassador from './EditAmbassador'

class ParselEditAmbassador extends React.Component {

 render() {
   const {...props} = this.props
   return (
     <IsConnected Component={EditAmbassador} {...props}/>
   )
 }
}



export default ParselEditAmbassador;
